import { ApiError } from '../errors/api-error.js';

export class WebhookSubscriptionService {
    constructor(api) { this.api = api; }

    async getAll(p = {}) { return this._wrap(() => this.api.getAll(p), 'Failed to list webhooks'); }
    async getById(id) { return this._wrap(() => this.api.getById(id), 'Failed to load webhook'); }
    async create(d) { return this._wrap(() => this.api.create(d), 'Failed to create webhook', 'Webhook oluşturuldu'); }
    async update(id, d) { return this._wrap(() => this.api.update(id, d), 'Failed to update webhook', 'Webhook güncellendi'); }
    async delete(id) { return this._wrap(() => this.api.delete(id), 'Failed to delete webhook', 'Webhook silindi'); }
    async test(id) { return this._wrap(() => this.api.test(id), 'Webhook test failed', 'Webhook test edildi'); }
    async listDeliveries(id, p = {}) { return this._wrap(() => this.api.listDeliveries(id, p), 'Failed to list deliveries'); }
    async replayDelivery(id, deliveryId) { return this._wrap(() => this.api.replayDelivery(id, deliveryId), 'Replay failed', 'Teslimat yeniden gönderildi'); }
    async rotateSecret(id) { return this._wrap(() => this.api.rotateSecret(id), 'Rotate secret failed', 'Anahtar yenilendi'); }

    async _wrap(fn, fb, okMsg) {
        try {
            const r = await fn();
            return { success: true, data: r?.data ?? r, pagination: r?.pagination, message: r?.message || okMsg };
        }
        catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || fb, 500, 'UNKNOWN_ERROR', e);
        }
    }
}
